import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import VueBase from '@/VueBase';
import helper from '@/services/helper';
import Q from 'q';
import api from '@/services/api';

@Component({
  computed: {
    ...mapState({
      ShowLanguages: 'ShowLanguages',
      ShowPrinter: 'ShowPrinter',
      AnonymousVoteEnabled: 'AnonymousVoteEnabled',
    }),
  },
})
export default class VoterAssignMixins extends VueBase {
  public readonly ShowLanguages!: string;
  public readonly ShowPrinter!: boolean;
  public readonly AnonymousVoteEnabled!: boolean;

  public Username: string = '';
  public Password: string = '';
  public IsLoading = true;

  get IdPlaceHolder() {
    if (process.env.VUE_APP_CLIENT == 'idf') {
      return 'אנא הזן מספר ת״ז';
    }
  }

  mounted() {
    this.onLoginClick();
  }

  async onLoginClick() {
    var username = this.Username;
    var password = this.Password;
    if ((!username || !password) && !this.AnonymousVoteEnabled) {
      return;
    }

    helper.swalShowLoading();
    var promise = Q.delay(500);
    const user = await (await api.VoterAssign(username, password)).getData(
      true,
      null,
      this.AnonymousVoteEnabled ? 200 : null,
    );
    if (!user) {
      this.IsLoading = false;
      return;
    }

    this.$store.commit('Login', user);
    await promise;

    if (this.AnonymousVoteEnabled) {
      this.$router.replace({ name: 'Start' });
    } else {
      this.$router.push({ name: 'Start' });
    }

    await Q.delay(500);
    helper.close();
  }
}
